import React, { useState } from 'react';
import { UserCircle, Save, Loader2 } from 'lucide-react';
import { api } from '../../api';
import { useAuth } from '../Auth/AuthContext';

export default function ProfilePage() {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.updateMyProfile(name);
      setMessage('Profil sparad!');
    } catch (e) { setMessage('Fel: ' + e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-md space-y-6">
      <h2 className="text-2xl font-black flex items-center gap-3">
        <UserCircle className="text-blue-600" /> Min profil
      </h2>
      <div className="bg-white rounded-2xl border border-slate-200 p-6">
        <div className="mb-4 p-3 bg-slate-50 rounded-xl">
          <p className="text-xs font-bold text-slate-400 uppercase">E-post</p>
          <p className="font-bold">{user?.email}</p>
        </div>
        <div className="mb-4 p-3 bg-slate-50 rounded-xl">
          <p className="text-xs font-bold text-slate-400 uppercase">Tenant</p>
          <p className="font-bold">{user?.tenant_name}</p>
        </div>
        <div className="mb-4 p-3 bg-slate-50 rounded-xl">
          <p className="text-xs font-bold text-slate-400 uppercase">Roll</p>
          <p className="font-bold">{user?.role === 'admin' ? 'Admin' : 'Medlem'}</p>
        </div>
        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">Ditt namn</label>
            <input value={name} onChange={e => setName(e.target.value)}
              className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Förnamn Efternamn" />
          </div>
          {message && <p className={`text-sm p-3 rounded-xl ${message.startsWith('Fel') ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>{message}</p>}
          <button type="submit" disabled={saving}
            className="w-full bg-blue-600 text-white py-3 rounded-xl font-black flex items-center justify-center gap-2">
            {saving ? <Loader2 className="animate-spin" size={18} /> : <><Save size={18} /> Spara</>}
          </button>
        </form>
      </div>
    </div>
  );
}
